/* eslint-disable import/prefer-default-export */
export const ADD_BOOKINGS = 'ADD_BOOKINGS'
export const REMOVE_BOOKINGS = 'REMOVE_BOOKINGS'
/** @deprecated ? Currently not relevant because we can not filter by date range */
// export const REPLACE_BOOKINGS = 'REPLACE_BOOKINGS'
